// |--------------------------------------------------------------------------
// |account アカウント画面
// |--------------------------------------------------------------------------
// |
// | ここではアカウントのapiを例として記述しています。
// | アカウントで使用するapiを全て記述します。
// | このapiを親のjs（functionApi.js）でimportして使用します。

/* ---------------------------------------------------------------------------
  一覧取得
---------------------------------------------------------------------------- */
export const list = async params => {
	return await axios.get(`/api/company`, {
		params: params
	});
};
/* ---------------------------------------------------------------------------
  詳細取得
---------------------------------------------------------------------------- */
export const show = async id => {
	return await axios.get(`/api/company/${id}`);
};

/* ---------------------------------------------------------------------------
  登録
---------------------------------------------------------------------------- */
// 通常の登録
export const store = async data => {
	return await axios.post(`/api/company`, data);
};
/* ---------------------------------------------------------------------------
  更新
---------------------------------------------------------------------------- */
export const update = async (id, data) => {
	console.log(data);
	return await axios.post(`/api/company/${id}`, data);
};
/* ---------------------------------------------------------------------------
  削除
---------------------------------------------------------------------------- */
export const destroy = async id => {
	return await axios.delete(`/api/company/${id}`);
};
